function l(e) {
  const {
    style: t,
    className: r,
    ...s
  } = e;
  return s;
}
export {
  l as omitStyleRenderProps
};
//# sourceMappingURL=index.js.map
